module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lj9nf"))).then(() => parcelRequire('iDabs'));